'use strict';

import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(...registerables, ChartDataLabels);
import { localDataStorageProvider } from "../services/localdatastorageprovider.js";

Chart.defaults.plugins.datalabels.anchor = 'end';
Chart.defaults.plugins.datalabels.align = 'end';

export class StatisticsListCtrl {

	storageNames = {
		query: 'StatisticsListCtrlQuery',
		chartQuery: 'StatisticsListCtrlChartQuery',
	};

	resultOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};

	query = {
		filters: {}
	};
	defaultQuery = {
		filters: {}
	};

	classif = {};
	selectedInterval = {};
	chips = [];
	promise;

	data = [];
	total = 0;
	total_autoreply = 0;
	total_messages = 0;
	initialized = false;
	chartInitialized = false;

	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	chart;
	chartData;

	constructor($scope, $filter, $http, $mdDialog, $httpParamSerializerJQLike, jsDataService, notify) {
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		
		$scope.chartFilter = {type: '0', status: '0'};
	}

	$onInit() {
		this.initQuery();
		this.initialized = true;
		//		this.loadData();
	}

	intervalChanged() {
		this.query.filters.created_from.value = new Date(this.selectedInterval.date_from * 1000);
		this.query.filters.created_to.value = new Date(this.selectedInterval.date_to * 1000);
	}
	initQuery() {
		const params = ['value'];
		this.defaultQuery = angular.merge({}, this.getDefaultQuery(), this.jsDataService.get('cfgQuery', {}));

		const tiny = this.getTinyDataForStorage(this.defaultQuery.filters, params);
		let storing = angular.copy(this.defaultQuery);
		storing.filters = tiny;
		const stored = new localDataStorageProvider(this.storageNames.query, storing);
		if (null === stored.getData().filters.created_from.value) {
			let currentDate = new Date();
			currentDate.setDate(1);
			stored.getData().filters.created_from.value = currentDate;
		}
		this.query = angular.merge({}, this.defaultQuery, stored.getData());
		const self = this;
		this.$scope.$watch(function () {
			return angular.toJson(self.query);
		}, function () {
			let toStore = angular.copy(self.query);
			toStore.filters = self.getTinyDataForStorage(toStore.filters, params);
			stored.setData(toStore);
			self.setChips();
			self.loadData();
		});

	}

	isFilters() {
		var o = angular.copy(this.query.filters);
		var d = angular.copy(this.defaultQuery.filters);
		//		delete o.query;
		//		delete d.query;
		if (angular.equals(o, d)) {
			return false;
		}
		return true;
	}

	getFilterChips() {
		let chips = [];
		for (let i in this.query.filters) {
			if (this.query.filters[i].isChip && this.query.filters[i].value && this.query.filters[i].value != this.defaultQuery.filters[i].value) {
				chips.push({
					key: i,
					field: this.query.filters[i].field,
					title: this.query.filters[i].title,
					value: this.getChipValue(this.query.filters[i])
				});
			}
		}
		return chips;
	}

	getChipValue(field) {
		let classifName = (typeof (field.classifName) !== 'undefined') ? field.classifName : field.field;
		if (field.type === 'classif' && typeof (this.classif[classifName]) !== 'undefined') {
			let val = this.$filter('filter')(this.classif[classifName], { id: field.value }, true);
			if (val.length > 0) {
				return val.shift().title;
			}
			else {
				return null;
			}
		}
		else if (field.type === 'datepicker' && typeof (field.value) !== 'undefined' && field.value !== '') {
			let format = 'yyyy-MM-dd';
			return this.$filter('date')(field.value, format);
		}
		else {
			return field.value;
		}
	}

	getCustomClasssifValue(field, defaultValue) {
		let val = this.getChipValue(field);
		if ((null === val || val === '') && defaultValue) {
			return defaultValue;
		}
		return val;
	}

	setChips() {
		this.chips = this.getFilterChips();
	}

	removeChip(chip) {
		this.chips = [];
		if (typeof (this.query.filters[chip.key]) !== 'undefined') {
			//			this.clearFilterField(this.query.filters[chip.key]);
			this.clearFilterKey(chip.key);
		}
		const self = this;
		setTimeout(function () {
			self.setChips();
		}, 20);
	}

	clearFilterField(filterField) {
		filterField.value = '';
	}

	clearFilterKey(key) {
		if (typeof (this.query.filters[key]) !== 'undefined') {
			if (typeof (this.defaultQuery.filters[key]) !== 'undefined') {
				this.query.filters[key].value = this.defaultQuery.filters[key].value;
			}
			else {
				this.query.filters[key].value = '';
			}
		}
	}

	clearFilters() {
		this.query.filters = angular.copy(this.getDefaultQuery().filters);
	}

	getDefaultQuery() {
		return this.defaultQuery;
	}


	loadData() {
		if (this.initialized) {
			const url = this.jsDataService.get('cfgDataUrl');
			if (url) {
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'GET',
					params: this.query
				}).then(function (response) {
					if (response.data.success) {
						self.data = response.data.data;
						self.total = response.data.total;
						self.total_autoreply = response.data.total_autoreply;
						self.total_messages = response.data.total_messages;
					}
					if (response.data.message) {
						self.notify(response.data.message, !response.data.success);
					}
				}, function (response) {
					console.log("HTTP ERROR");
					console.log(response);
				});
			}
		}
	}

	getTinyDataForStorage(obj, param) {
		let outp = {};
		for (let i in obj) {
			outp[i] = {};
			for (let k of param) {
				if (typeof (obj[i][k]) !== 'undefined') {
					outp[i][k] = obj[i][k];
				}
			}
		}
		return outp;
	}



	varReplace(text, params) {
		for (let i in params) {
			let reg = new RegExp("\\{" + i + "\\}", "i");
			text = text.replace(reg, params[i]);
		}
		return text;
	}


	getFilteredClassif(classifName, filterField, filterValue) {
		if (typeof (this.classif[classifName]) === 'undefined') {
			return [];
		}
		if (filterValue && filterValue > 0) {
			let filterParams = {};
			filterParams[filterField] = filterValue;
			return this.$filter('filter')(this.classif[classifName], filterParams, true);
		}
		return [];
	}

	unsetProperty(prop) {
		if (typeof (prop.value) !== 'undefined') {
			prop.value = '';
			this.setChips();
		}
	}

	calculateSum(param) {
		if (typeof (this.data[param]) === 'undefined') {
			return 0;
		}
		let sum = 0;
		for (const i in this.data[param]) {
			if (typeof (this.data[param][i].count) !== 'undefined') {
				sum += parseInt(this.data[param][i].count);
			}
		}
		return sum;
	}

	onChartTabOpen() {
		if(!this.chartInitialized) {
			this.$scope.$watch('chartFilter', (newValue, oldValue) => {
				this.loadChartData();
			}, true);
			this.chartInitialized = true;
		}
	}
	
	loadChartData() {
		this.promise = this.$http({
			url: this.jsDataService.get('chartDataUrl'),
			method: 'GET',
			params: this.$scope.chartFilter
		}).then((response) => {
			if (response.data.success) {
				this.chartData = response.data.data;
				this.renderChart(response.data.data);
			}
			if (response.data.message) {
				self.notify(response.data.message, !response.data.success);
			}
		}, (response) => {
			console.log("HTTP ERROR");
			console.log(response);
		});
	}
	
	renderChart(data) {
		if(this.chart) {
			this.chart.destroy();
			this.chart = null;
		}
		
		const ctx = document.getElementById('stats-chart');

		this.chart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: ['Metinis', '1 ketvirtis', '2 ketvirtis', '3 ketvirtis', '4 ketvirtis'],
				datasets: data
			},
			options: {
				scales: {
					y: {
						beginAtZero: true,
						ticks: {
						  min: 0,
						  stepSize: 1,
						},
					}
				},
				responsive: true,
			}
		});
		
		if(data.length > 2) {
			for(let i = 0; i < data.length - 2; i++) {
				this.chart.setDatasetVisibility(i, false);
			}
			this.chart.update();
		}
	}
	
	resetChartFilter(){
		this.$scope.chartFilter.type = '0';
		this.$scope.chartFilter.status = '0';
	}

}
